module.exports = __webpack_public_path__ + "img/aulasEmpty.708afc56.png";